import FullIndex from './full.vue';
import MobFull from './mob-full.vue';

export const componentMap = {
	full: FullIndex,
	'mob-full': MobFull,
};